import React, { useEffect, useRef } from "react";
import { motion, useAnimation, useInView } from "framer-motion";
import {
  BiCreditCardAlt,
  BiRefresh,
  BiAnalyse,
  BiShieldQuarter,
} from "react-icons/bi";

const solutions = [
  {
    icon: BiShieldQuarter,
    title: "24/7 Support",
    desc: "Get help anytime with our dedicated support team. We’re here for you around the clock – chat, email, or call anytime.",
  },
   {
    icon: BiRefresh,
    title: "Fraud Protection",
    desc: "Stay protected with our advanced fraud detection system. AI-powered security shields your business from suspicious activities in real time.",
  },
   {
    icon: BiAnalyse,
    title: "Multiple Payment Methods",
    desc: "Support cards, digital wallets & local payment options. Offer customers the flexibility they expect and increase your conversion rates.",
  },
  {
    icon: BiCreditCardAlt,
    title: "Instant Settlements",
    desc: "Enjoy real-time payment settlements to your bank account, ensuring fast and reliable access to your funds.",
  },
 
 
  
];

// Animate text from left
const leftVariants = {
  hidden: { opacity: 0, x: -50 },
  visible: (i) => ({
    opacity: 1,
    x: 0,
    transition: { delay: i * 0.1, duration: 0.5, ease: "easeOut" },
  }),
};

// Animate cards from right
const cardVariants = {
  hidden: { opacity: 0, x: 50 },
  visible: (i) => ({
    opacity: 1,
    x: 0,
    transition: { delay: i * 0.15, duration: 0.5, ease: "easeOut" },
  }),
};

const SmartSolutions = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: false, amount: 0.3 });
  const controls = useAnimation();

  useEffect(() => {
    if (isInView) {
      controls.start("visible");
    } else {
      controls.start("hidden");
    }
  }, [isInView, controls]);

  return (
    <section
      ref={ref}
      style={{
        background: "#f9f9f9",
        padding: "40px 20px",
      }}
    >
      <div
        style={{
          maxWidth: "1280px",
          margin: "0 auto",
          display: "flex",
          flexWrap: "wrap",
          alignItems: "flex-start",
          justifyContent: "space-between",
          gap: "40px",
        }}
      >
        {/* Left Column */}
        <div style={{ flex: "1 1 45%", minWidth: "280px" }}>
          <motion.p
            custom={0}
            variants={leftVariants}
            initial="hidden"
            animate={controls}
            style={{
              color: "#2196f3",
              fontWeight: "600",
              fontSize: "16px",
              marginTop: "80px",
            }}
          >
            <span style={{ marginRight: "8px" }}>✎</span> Core Product
          </motion.p>

          <motion.h2
            custom={1}
            variants={leftVariants}
            initial="hidden"
            animate={controls}
            style={{
              fontSize: "38px",
              fontWeight: "700",
              marginBottom: "20px",
              lineHeight: "1.2",
            }}
          >
            Unlock New Revenue Streams with{" "}
            <span
              style={{
                background: "linear-gradient(to right, #0d4f7d, #99c614)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
              }}
            >
              Scalable Payment Solutions
            </span>
          </motion.h2>

          <motion.p
            custom={2}
            variants={leftVariants}
            initial="hidden"
            animate={controls}
            style={{
              color: "#5f6368",
              fontSize: "16px",
              marginBottom: "30px",
            }}
          >
            Guarantee reliability for websites, apps or servers. We deliver
            round-the-clock, high-quality managed web hosting services.
          </motion.p>

        
        </div>

        {/* Right Column - Cards */}
        <div
          style={{
            flex: "1 1 50%",
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
            gap: "20px",
          }}
        >
          {solutions.map((sol, i) => {
            const Icon = sol.icon;
            return (
              <motion.div
                key={i}
                custom={i}
                variants={cardVariants}
                initial="hidden"
                animate={controls}
                whileHover={{
                  rotate: -1,
                  backgroundColor: "#1c9b3c",
                  color: "#fff",
                  boxShadow: "0 8px 20px rgba(0, 0, 0, 0.15)",
                  transition: { duration: 0.3, ease: "easeInOut" },
                }}
                style={{
                  background: "#fff",
                  padding: "24px",
                  borderRadius: "12px",
                  boxShadow: "0 4px 12px rgba(0,0,0,0.06)",
                  display: "flex",
                  flexDirection: "column",
                  gap: "12px",
                  transition: "all 0.3s ease",
                }}
              >
                <Icon size={40} />
                <h5 style={{ fontWeight: "600", fontSize: "18px" }}>
                  {sol.title}
                </h5>
                <p style={{ fontSize: "14px" }}>{sol.desc}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default SmartSolutions;
